import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'proffeo-users',
  template: '<router-outlet></router-outlet>',
  imports: [RouterOutlet]
})
export class UsersComponent {}
